import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        marginBottom: "8px",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const NoticeSkeleton = () => {
  return (
    <div
      className="r_detailsAdditionalText"
      style={{ backgroundColor: "#F9FBFC" }}
    >
      <SkeletonTheme
        baseColor="#D8DBE0"
        highlightColor="#EDF1F6"
        borderRadius={"4px"}
      >
        <div style={{ marginBottom: "18px" }}>
          <Skeleton height={31} width={160} />
        </div>
        <Skeleton wrapper={Box} width={"85%"} />
        <Skeleton wrapper={Box} count={2} />
      </SkeletonTheme>
    </div>
  );
};

export default NoticeSkeleton;
